import { motion } from "framer-motion";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { positions } from "./positions";

interface PositionSelectProps {
  selectedPosition: number | null;
  onPositionSelect: (positionId: number) => void;
  onStartQuiz: () => void;
}

export function PositionSelect({
  selectedPosition,
  onPositionSelect,
  onStartQuiz,
}: PositionSelectProps) {
  const handleStartQuiz = () => {
    if (!selectedPosition) {
      toast.error("请先选择一个位置");
      return;
    }
    onStartQuiz();
  };

  return (
    <motion.div
      key="position-select"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="space-y-6"
    >
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-white">Apex 打法风格测试</h1>
        <p className="text-gray-400">
          选择你认为最适合自己的位置，然后回答10个深度问题，AI将为你的打法风格进行锐评分析
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {positions.map((position) => {
          const Icon = position.icon;
          return (
            <Card
              key={position.id}
              className={`cursor-pointer transition-all duration-200 hover:scale-105 ${
                selectedPosition === position.id
                  ? "ring-2 ring-red-500 bg-red-500/10"
                  : "hover:bg-foreground/10"
              }`}
              onClick={() => onPositionSelect(position.id)}
            >
              <CardHeader className="text-center">
                <div
                  className={`w-16 h-16 rounded-full ${position.color} mx-auto flex items-center justify-center mb-2`}
                >
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <CardTitle className="text-xl">{position.name}</CardTitle>
                <CardDescription>{position.description}</CardDescription>
              </CardHeader>
              <CardContent className="space-y-3">
                <div>
                  <h4 className="font-semibold mb-2">特点：</h4>
                  <div className="flex flex-wrap gap-1">
                    {position.characteristics.map((char) => (
                      <Badge key={char} variant="secondary" className="text-xs">
                        {char}
                      </Badge>
                    ))}
                  </div>
                </div>
                <div>
                  <h4 className="font-semibold mb-2">推荐英雄：</h4>
                  <div className="flex flex-wrap gap-1">
                    {position.recommendedLegends.map((legend) => (
                      <Badge key={legend} variant="outline" className="text-xs">
                        {legend}
                      </Badge>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="text-center">
        <Button
          onClick={handleStartQuiz}
          disabled={!selectedPosition}
          size="lg"
          className="bg-red-500 hover:bg-red-600"
        >
          开始测试
        </Button>
      </div>
    </motion.div>
  );
}
